import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createVNode as _createVNode, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/jyranians-mountain.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-27b6f0d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "outcome-panel-content"
}
const _hoisted_2 = {
  key: 1,
  "data-test": "md-outcome-tile-default",
  class: "default-outcome-content center-flex"
}
const _hoisted_3 = { class: "outcome-panel-content team-outcome" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { "data-test": "md-outcome-tile-default-title" }, "Choose your pathway", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  style: {"margin-bottom":"10px"},
  class: "btn btn-primary btn-large",
  "data-test": "md-outcome-tile-button"
}, " Go ", -1))
const _hoisted_6 = {
  key: 0,
  class: "selected-outcome-content",
  "data-test": "md-outcome-tile-content"
}
const _hoisted_7 = { class: "outcome-tile-image-container" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "outcome-tile-image-container pathway-image" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  class: "btn btn-primary btn-large",
  "data-test": "md-outcome-tile-button"
}

import { computed, ref } from "vue";
import Stepper from "../team-outcomes/progress-stepper.vue";
import DashboardPanel from "../dashboard-panel.vue";
import {
  CmsPersonalGoal,
  CmsPersonalPathway,
  CmsRichText,
} from "../../services/cms/cms-type-definitions";
import {
  PersonalPathwayUserProgressApiModel,
  PersonalPathwayCompletedStepApiModel,
  PersonalPathwayProgressApiModel,
} from "../../api-models";
import cms from "../../services/cms/cms";
import { useAxios } from "../../composables/api";
import LoadingPage from "../../views/loading-page.vue";
import TileKebabMenu from "../tile-kebab-menu.vue";

export type OutcomeTileButtonText = "Go" | "Continue" | "Complete pathway";

export interface PersonalOutcomeTile {
  outcomeImgSrc?: string;
  outcomeTitle?: string | CmsRichText;
  pathwayImgSrc?: string;
  pathwayTitle?: string | CmsRichText;
  buttonText: OutcomeTileButtonText;
  buttonUrl: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-outcome-tile',
  emits: ["openKebab", "update:isChangeOutcomeModalDisplayed"],
  setup(__props, { expose: __expose, emit: __emit }) {

const outcomeTileKebab = ref();

const emit = __emit;

const isDataLoaded = ref(false);

const isDefaultImageLoaded = ref(false);

const pathwayDoc = ref<CmsPersonalPathway | null>(null);

const currentOutcome = ref<CmsPersonalGoal | null>(null);

const pathwayProgress = ref<PersonalPathwayCompletedStepApiModel | null>(null);

const currentPathway = ref<PersonalPathwayUserProgressApiModel | null>(null);

const isUserOnAPathway = ref(false);

const pathwayStepCount = computed<number>(() => {
  return pathwayDoc.value?.data.pathway_steps.length ?? 0;
});

const completedStep = computed<number>(() => {
  return pathwayProgress.value?.stepIndex ?? -1;
});

const handleChangeOutcome = (): void => {
  emit("update:isChangeOutcomeModalDisplayed", true);
};

const handleDefaultImageLoad = () => {
  isDefaultImageLoaded.value = true;
};

const onKebabOpen = () => {
  emit("openKebab");
};

const hasUserCompletedLastStep = (): boolean => {
  if (pathwayProgress.value?.stepIndex && pathwayDoc.value) {
    const pathwaySteps = pathwayDoc.value.data.pathway_steps;
    const finalStep = pathwaySteps[pathwaySteps.length - 1];
    return finalStep.pathway_step.id === pathwayProgress.value.cmsStepId && isUserOnAPathway.value;
  }
  return false;
};

const outcomeTileContent = computed<PersonalOutcomeTile>(() => {
  const isReadyToComplete = hasUserCompletedLastStep();

  let buttonText = "Go";
  if (isUserOnAPathway.value) {
    buttonText = isReadyToComplete ? "Complete pathway" : "Continue";
  }

  let buttonUrl = "/my/outcomes";
  if (isUserOnAPathway.value && currentPathway.value) {
    buttonUrl = isReadyToComplete
      ? "/my/complete"
      : `/my/pathway/${currentPathway.value.cmsPersonalPathwayUid}`;
  }

  return {
    outcomeImgSrc: currentOutcome.value?.data.image.url,
    outcomeTitle: currentOutcome.value?.data.full_title,
    pathwayImgSrc: pathwayDoc.value?.data.title_image.url,
    pathwayTitle: pathwayDoc.value?.data.title,
    buttonText,
    buttonUrl,
  } as PersonalOutcomeTile;
});

const getCurrentOutcomeAndPathwayData = async (
  pathwayData: PersonalPathwayProgressApiModel,
): Promise<void> => {
  currentPathway.value = pathwayData.currentPathway;
  pathwayProgress.value = pathwayData.pathwayProgress;
  pathwayDoc.value = await cms.getById(
    "cms-personal-pathway",
    currentPathway.value.cmsPersonalPathwayId,
  );
  currentOutcome.value = await cms.getById(
    "cms-personal-goal",
    currentPathway.value.cmsPersonalOutcomeId,
  );
};

const { promise } = useAxios<PersonalPathwayProgressApiModel>("/api/personalpathway/current");
promise.then((pathwayData) => {
  if (pathwayData.currentPathway) {
    getCurrentOutcomeAndPathwayData(pathwayData).then(() => {
      isUserOnAPathway.value = !pathwayData.currentPathway.isCompleted;
      isDataLoaded.value = true;
    });
  } else {
    isDataLoaded.value = true;
  }
});

__expose({
  outcomeTileKebab,
  isUserOnAPathway,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardPanel, {
    title: "My Pathway",
    href: outcomeTileContent.value.buttonUrl,
    "data-test": "md-outcome-tile"
  }, {
    default: _withCtx(() => [
      (isDataLoaded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!!currentPathway.value?.cmsPersonalPathwayId && !currentPathway.value?.isCompleted)
              ? (_openBlock(), _createBlock(TileKebabMenu, {
                  key: 0,
                  "data-test": "kebab-menu",
                  ref_key: "outcomeTileKebab",
                  ref: outcomeTileKebab,
                  onOpenKebab: onKebabOpen
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _withModifiers(handleChangeOutcome, ["stop","prevent"]),
                        "data-test": "change-outcome"
                      }, "Change pathway")
                    ])
                  ]),
                  _: 1
                }, 512))
              : _createCommentVNode("", true),
            (!isUserOnAPathway.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_Transition, {
                    name: "fade",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                          alt: "choose your pathway image",
                          src: _imports_0,
                          class: "outcome-tile-default-img",
                          onLoad: handleDefaultImageLoad,
                          "data-test": "md-outcome-tile-default-img"
                        }, null, 32),
                        _hoisted_4,
                        _hoisted_5
                      ], 512), [
                        [_vShow, isDefaultImageLoaded.value]
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (isUserOnAPathway.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: outcomeTileContent.value.outcomeImgSrc,
                          alt: `${_unref(cms).asText(outcomeTileContent.value.outcomeTitle)} image`,
                          class: "outcome-tile-outcome-image",
                          "data-test": "md-outcome-tile-outcome-img"
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", {
                        innerHTML: _unref(cms).asHtml(outcomeTileContent.value.outcomeTitle),
                        class: "outcome-tile-outcome-title",
                        "data-test": "md-outcome-tile-outcome-title"
                      }, null, 8, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: outcomeTileContent.value.pathwayImgSrc,
                          alt: `${_unref(cms).asText(outcomeTileContent.value.pathwayTitle)} image`,
                          class: "outcome-tile-pathway-image",
                          "data-test": "md-outcome-tile-pathway-img"
                        }, null, 8, _hoisted_11)
                      ]),
                      _createElementVNode("h4", {
                        innerHTML: _unref(cms).asText(outcomeTileContent.value.pathwayTitle),
                        class: "outcome-tile-pathway-title",
                        "data-test": "md-outcome-tile-pathway-title"
                      }, null, 8, _hoisted_12),
                      (isUserOnAPathway.value && !currentPathway.value.dateCompleted)
                        ? (_openBlock(), _createBlock(Stepper, {
                            key: 0,
                            "completed-step": completedStep.value,
                            "steps-count": pathwayStepCount.value,
                            "show-tooltip": true,
                            "data-test": "md-outcome-tile-progress"
                          }, null, 8, ["completed-step", "steps-count"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", _hoisted_13, _toDisplayString(outcomeTileContent.value.buttonText), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
    ]),
    _: 1
  }, 8, ["href"]))
}
}

})